"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropTheHammerEffectHandler = exports.DropTheHammerEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DropTheHammerEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.DropTheHammer;
        this.__typeName = "DropTheHammer";
        this.name = "Drop the Hammer";
        this.harmful = false;
    }
}
exports.DropTheHammerEffectArgs = DropTheHammerEffectArgs;
let DropTheHammerEffectHandler = class DropTheHammerEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerIds = [];
        const scriptArgs = {
            hammerId: state.targetId,
            sunbreakerId: state.creatorId
        };
        state.meta.eventHandlerIds = [
            container.registerEventHandler(state.targetId, EventType_1.EventType.DamageDealt, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_DropTheHammer_OnHammerDamage", scriptArgs))
        ];
    }
    remove(sequence, container, state) {
        for (const eventHandlerId of state.meta.eventHandlerIds) {
            container.cancelEventHandler(eventHandlerId);
        }
    }
};
DropTheHammerEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DropTheHammer)
], DropTheHammerEffectHandler);
exports.DropTheHammerEffectHandler = DropTheHammerEffectHandler;
